import { AnyAction } from 'redux';

export enum PlayActionTypes {
    PLAY_ROM_FILE = 'PLAY__PLAY_ROM_FILE',
    STOP_PLAYING = 'PLAY__STOP_PLAYING',
}

export interface PlayRomFileAction extends AnyAction {
    type: PlayActionTypes.PLAY_ROM_FILE;
    romId: string;
}

export interface StopPlayingAction extends AnyAction {
    type: PlayActionTypes.STOP_PLAYING;
}

export type PlayAction = PlayRomFileAction | StopPlayingAction;

export function isPlayAction(action: AnyAction): action is PlayAction {
    return action.type in PlayActionTypes;
}
